import './archive-edit-screen-header.scss'

import { defineComponent, PropType } from 'vue';
import { faArrowLeft, faCheck, faEdit, faCircleNotch } from '@fortawesome/free-solid-svg-icons'

import { ArchiveResource, getTranslatedString, TranslatedString } from '@skinsoft/types';
import { archiveSelectors, thesaurusTermSelectors } from '@skinsoft/selectors';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { BasicArchiveCard } from '@skinsoft/ui2';

export const ArchiveEditScreenHeader = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sBasicArchiveCard: BasicArchiveCard,
    },
    props: {
        archive: {
            type: Object as PropType<ArchiveResource>,
            required: true,
        },
        actionsAvailable: {
            type: Boolean,
            default: false,
        },
    },
    template: require('./archive-edit-screen-header.html'),
    data() {
        return {
            archiveTypes: '',
            descriptionLevel: null as TranslatedString | undefined | null,
        }
    },
    mounted() {
        this.updateArchiveTypes()
        this.updateDescriptionLevel()
    },
    computed: {
        cote(): string {
            return archiveSelectors.cote(this.archive) ?? ""
        },
    },
    methods: {
        async updateArchiveTypes() {
            const types = archiveSelectors.archiveTypes(this.archive)

            let res = ''
            const separator = " ; "

            if(types?.length) {
                for(const type of types) {
                    if(type?.archiveType) {
                        const thesaurusTermId = (type.archiveType as any).ref ?? type.archiveType
                        const thesaurusTerm = await this.$thesaurusTermDataStore.fetchOne(thesaurusTermId).toPromise()
                        if(thesaurusTerm) {
                            const thesaurusTermTranslatedString = thesaurusTermSelectors.preferredTerm(thesaurusTerm)
                            if(thesaurusTermTranslatedString) {
                                const thesaurusTermValue = getTranslatedString(
                                    thesaurusTermTranslatedString,
                                    this.$i18n.locale
                                )
                                if(thesaurusTermValue) {
                                    res += `${thesaurusTermValue}${separator}`
                                }
                            }
                        }
                    }
                }
            }

            if(res.length) {
                res = res.slice(0, -separator.length)
            }
            this.archiveTypes = res
        },

        async updateDescriptionLevel() {
            this.descriptionLevel = null
            const thesaurusTermId = archiveSelectors.descriptionLevel(this.archive)
            if(thesaurusTermId) {
                const thesaurusTerm = await this.$thesaurusTermDataStore.fetchOne(thesaurusTermId).toPromise()
                if(thesaurusTerm) {
                    this.descriptionLevel = thesaurusTermSelectors.preferredTerm(thesaurusTerm)
                }
            }
        },

        onMainButtonClick() {},
    },
    watch: {
        archive: {
            handler() {
                this.updateArchiveTypes()
                this.updateDescriptionLevel()
            },
        },
    },
})
